// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"184":"7eb52f30","206":"bf9b786c"}[chunkId] + ".chunk.css";
};